import React, { useState, useEffect } from 'react';
import { Outlet } from "react-router-dom";
import { useMediaQuery } from "react-responsive"
import Header from './Header'
import Sidebar from './Sidebar'

import classNames from 'classnames'

const Index = () => {
    let isMd = useMediaQuery({ query: "(max-width: 1023px)" })
    const [isOpenSidebar, setIsOpenSidebar] = useState(isMd ? false : true)
    useEffect(() => {
        if (isMd) {
          setIsOpenSidebar(false);
        } else {
          setIsOpenSidebar(true);
        }
      }, [isMd]);

    return (
        <>
            <Sidebar isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}  />
            <div className={classNames({
                "flex flex-col flex-1 bg-slate-200  min-h-screen text-slate-600 ": true,
                "md:pl-64": isOpenSidebar === true,
                "md:pl-0": isOpenSidebar === false,
            })}>
                <Header setIsOpenSidebar={setIsOpenSidebar} isOpenSidebar={isOpenSidebar} />
                <Outlet />
            </div>
        </>

    );
}

export default Index;
